import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function OngFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cause, setCause] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedOng, setSelectedOng] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const causes = [
    { id: "all", name: "Todas" },
    { id: "animals", name: "Animais" },
    { id: "environment", name: "Meio Ambiente" },
    { id: "education", name: "Educação" },
    { id: "health", name: "Saúde" },
    { id: "social", name: "Assistência Social" },
    { id: "children", name: "Crianças" },
    { id: "elderly", name: "Idosos" },
    { id: "culture", name: "Cultura" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/ong?page=${pageNum}&limit=12`;
      if (cause !== "all") url += `&cause=${cause}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching ong:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [cause]);

  const handleEditPost = (post) => {
    setSelectedOng(null);
    setEditingPost(post);
  };

  const handlePostUpdated = (updatedPost) => {
    setPosts((prev) => prev.map((p) => (p._id === updatedPost._id ? updatedPost : p)));
    setEditingPost(null);
  };

  const handlePostDeleted = (postId) => {
    setPosts((prev) => prev.filter((p) => p._id !== postId));
    setSelectedOng(null);
  };

  if (loading && posts.length === 0) {
    return <div className="ong_feed_loading"><div className="ong_loader"></div><span>Carregando ONGs...</span></div>;
  }

  return (
    <div className="ong_feed">
      <div className="ong_header">
        <h1>ONGs e Projetos Sociais</h1>
        <p>Apoie causas que transformam vidas</p>
      </div>

      <div className="ong_filters">
        {causes.map((c) => (
          <button key={c.id} className={cause === c.id ? "active" : ""} onClick={() => setCause(c.id)}>
            {c.name}
          </button>
        ))}
      </div>

      {posts.length === 0 ? (
        <div className="ong_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>
          <h3>Nenhuma ONG encontrada</h3>
          <p>Cadastre sua organização!</p>
        </div>
      ) : (
        <div className="ong_grid">
          {posts.map((post) => (
            <div key={post._id} className="ong_card" onClick={() => setSelectedOng(post)}>
              <div className="ong_card_image">
                <img src={post.ongData?.coverImage || post.images?.[0]?.url || post.images?.[0] || "/images/default-ong.png"} alt="" />
                <span className="ong_cause_badge">
                  {causes.find(c => c.id === post.ongData?.cause)?.name || "Causa"}
                </span>
              </div>
              <div className="ong_card_content">
                <div className="ong_logo">
                  <img src={post.ongData?.logo || post.user.picture} alt="" />
                </div>
                <h3>{post.ongData?.name || post.text}</h3>
                <p className="ong_mission">{post.ongData?.mission}</p>
                <div className="ong_stats">
                  {post.ongData?.volunteersCount > 0 && (
                    <span>
                      <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                      </svg>
                      {post.ongData.volunteersCount} voluntários
                    </span>
                  )}
                  {post.ongData?.projectsCount > 0 && (
                    <span>
                      <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                      </svg>
                      {post.ongData.projectsCount} projetos
                    </span>
                  )}
                </div>
                <div className="ong_card_actions">
                  <button className="ong_donate_btn">Doar</button>
                  <button className="ong_volunteer_btn">Voluntariar</button>
                  <div onClick={(e) => e.stopPropagation()}>
                    <FeedPostMenu
                      post={post}
                      onEdit={handleEditPost}
                      onPostDeleted={handlePostDeleted}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="ong_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}

      {selectedOng && (
        <div className="ong_modal_overlay" onClick={() => setSelectedOng(null)}>
          <div className="ong_modal" onClick={(e) => e.stopPropagation()}>
            <button className="ong_modal_close" onClick={() => setSelectedOng(null)}>✕</button>

            <div className="ong_modal_header">
              <img src={selectedOng.ongData?.coverImage || selectedOng.images?.[0]} alt="" className="ong_modal_cover" />
              <div className="ong_modal_logo">
                <img src={selectedOng.ongData?.logo || selectedOng.user.picture} alt="" />
              </div>
            </div>

            <div className="ong_modal_body">
              <span className="ong_modal_cause">
                {causes.find(c => c.id === selectedOng.ongData?.cause)?.name}
              </span>
              <h2>{selectedOng.ongData?.name}</h2>

              <div className="ong_modal_mission">
                <h4>Nossa Missão</h4>
                <p>{selectedOng.ongData?.mission}</p>
              </div>

              {selectedOng.ongData?.description && (
                <div className="ong_modal_about">
                  <h4>Sobre nós</h4>
                  <p>{selectedOng.ongData.description || selectedOng.text}</p>
                </div>
              )}

              <div className="ong_modal_info">
                <div className="ong_info_item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                  </svg>
                  <span>{selectedOng.ongData?.location || "Não informado"}</span>
                </div>
                {selectedOng.ongData?.website && (
                  <div className="ong_info_item">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/>
                    </svg>
                    <a href={selectedOng.ongData.website} target="_blank" rel="noreferrer">{selectedOng.ongData.website}</a>
                  </div>
                )}
              </div>

              {selectedOng.ongData?.volunteerNeeds?.length > 0 && (
                <div className="ong_modal_needs">
                  <h4>Precisamos de voluntários para</h4>
                  <ul>
                    {selectedOng.ongData.volunteerNeeds.map((need, i) => (
                      <li key={i}>{need}</li>
                    ))}
                  </ul>
                </div>
              )}

              {selectedOng.ongData?.projects?.length > 0 && (
                <div className="ong_modal_projects">
                  <h4>Projetos Ativos</h4>
                  <div className="ong_projects_list">
                    {selectedOng.ongData.projects.map((project, i) => (
                      <div key={i} className="ong_project_item">
                        <h5>{project.name}</h5>
                        <p>{project.description}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selectedOng.ongData?.donationInfo && (
                <div className="ong_modal_donation">
                  <h4>Como Doar</h4>
                  <p>{selectedOng.ongData.donationInfo}</p>
                </div>
              )}

              <div className="ong_modal_actions">
                <button className="ong_modal_donate_btn">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                  </svg>
                  Fazer Doação
                </button>
                <button className="ong_modal_volunteer_btn">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                  </svg>
                  Quero ser Voluntário
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
